export const BACK_TO_LOGIN_BUTTON_COPY = 'Back to log in';
export const SUCCESS_TEXT = 'Reset link sent!';
